const isCortexPath = (path = '') => path === '/cortex' || path.startsWith('/cortex/')

const getNavigationNodes = (nodes, currentPath) =>
    nodes
        .filter((node) => (isCortexPath(currentPath) ? isCortexPath(node.path) : !node.hideFromNav))
        // The sidebar builds a mutable tree; never mutate Gatsby's shared query data.
        .map((node) => ({ ...node }))

module.exports = { isCortexPath, getNavigationNodes }
